import { Crown } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 py-10 px-5 sm:px-8 bg-[#05030A]"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <Crown
            className="w-4 h-4 text-[#D4AF37]"
            strokeWidth={1.5}
          />
          <span className="font-serif text-sm text-white tracking-wide">
            Royal Rides{" "}
            <span className="italic gold-text">Queen</span>
          </span>
        </div>
        <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-[#A89FBB]">
          © {new Date().getFullYear()} · Private · Safe · Luxury
        </p>
      </div>
    </footer>
  );
};
